import Vue from 'vue'
import Vuex from 'vuex'
import actions from './actions'
import getters from './getters'
import defaultState from './state'
import mutations from './mutations'
Vue.use(Vuex)

const isDev = process.env.NODE_ENV === 'development'
const store = new Vuex.Store({
  strict: isDev,
  state: defaultState,
  getters: getters,
  actions,
  mutations
})

export default store



// WEBPACK FOOTER //
// ./src/store/index.js